<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="交易状态" name="transactionStatus">
                <DictSelect
                            v-model:value="searchForm.transactionStatus"
                            :dict-name="financeDict.ADUIT_STATUS"
                            placeholder="请选择交易状态"
                        />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>

        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #propertyNames="{record}">
                <a @click="onDetail(record)">{{record.propertyNames}}</a>
            </template>
            <template #brandIndustryType="{text}">
                <dict-render :dict-obj="dictObjs['projectType']" :text="text"></dict-render>
            </template>
            <template #propertyType="{text}">
                <dict-render :dict-obj="dictObjs['property_type']" :text="text"></dict-render>
            </template>
            <template #auditStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['aduit_status']" :text="text"
                                 :style="dictObjs['aduit_status']?.cssClass"></dict-render>
                </a-tag>
            </template>
            <template #transaction_status="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['transaction_status']" :text="text"
                                 :style="dictObjs['transaction_status']?.cssClass"></dict-render>
                </a-tag>
            </template>

            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onSellerCancel(record)">取消交易</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <PublishTransactionsModal ref="publishModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>

</template>

<script>
    import AddOrEditModal from "./components/AddOrEditModal";
    import PublishTransactionsModal from "./components/PublishTransactionsModal"
    import {dictMixin, tableListMixin} from "@/mixins";
    import {tradeApi,TransactionIntention} from "@/api/knowledge";
    import DictRender from "@/components/other/DictRender";
    import Detail from "./components/DetailModal"
    import DictSelect from "@/components/other/DictSelect";
    import {financeDict} from "@/config/variableConfig";

    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        // {title: "单号", dataIndex: "id", key: "id"},
        {title: "名称", dataIndex: "propertyNames", key: "propertyNames", slots: {customRender: "propertyNames"}},
        {title: "产权所属", dataIndex: "userName", key: "userName"},
        {title: "产权类型", dataIndex: "propertyType", key: "propertyType", slots: {customRender: "propertyType"}},
        // {title: "交易价格", dataIndex: "price", key: "price"},
        {title: "交易状态", dataIndex: "transactionStatus", key: "transactionStatus",slots: {customRender: "transaction_status"}},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];
    export default {
        name: "index",
        mixins: [tableListMixin, dictMixin],
        components: {
            DictRender, AddOrEditModal, Detail,PublishTransactionsModal,DictSelect,
        },
        data() {
            return {
                financeDict,
                dictNames: 'projectType,aduit_status,property_type,transaction_status',
                columns,
                queryParamFixed: {},
                listUrl: tradeApi.pagelistPurchase,
                listKeyField: "id",
                deleteUrl: TransactionIntention.remove,
                jointId: null,
            }
        },
        methods: {
            onAdd() {
                this.onShowModal('modal');
            },
            onEdit(record) {
                this.getAction({
                    url: tradeApi.detail,
                    params: {id: record.id}
                }).then(res => {
                    this.onShowModal('modal', res);
                })
            },
            onSellerCancel(record) {
                console.log("record",record)
                this.postAction({
                    url: tradeApi.purchaserCancel,
                    params: {id: record.transactionIntentionId}
                }).then(res => {
                    console.log("res", res)
                })
            },
            onDetail(record) {
                this.getAction({
                    url: tradeApi.detail,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    this.onShowModal("detailmodal", res)
                })
            },
            onJoint(record) {
                this.onShowModal('publishModal',{propertyId:record.id,propertyType:"2"});
            },

        }
    }
</script>

<style scoped>

</style>
